<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<meta charset="utf-8"/>
<link href="styles/custom.css" rel="stylesheet" type="text/css"/>
<title>Debt Bomb</title>
<section epub:type="contributors">
<p class="ctfront"><span epub:type="pagebreak" id="page_iii" title="iii"><a href="#/contenttoc#r01" id="a01">PRAISE FOR DEBT BOMB</a></span></p>
<p class="tx1"> “A timely and fast-paced spy thriller by a former U.S. intelligence official, <i>Debt Bomb</i> is a sobering reminder of the national security threat posed by the ballooning U.S. national debt and the silence of Republican spending hawks in the Trump years. With this debut novel, Mike Ginsberg may be destined to be an American John LeCarre.”</p>
<p class="txr"> —John Bellinger, Former Legal Adviser to the National Security Council</p>
<div class="image">
<p class="ser"><img alt="Image" src="images/himg-3-1.jpg"/></p>
</div>
<p class="tx1"> “A deftly crafted thriller that kept me turning pages—through politics, money, and murder—to the ending I didn’t see coming.”</p>
<p class="txr"> —Chris DeRose, New York Times Bestselling Author of <i>The Fighting Bunch</i></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter.vue?a64a6364